<template>
    <div>
        <div id="scroller"></div>
        <Navigation />
        <Header />

        <Nuxt />

        <CallUs />
        <Scroller />
        <Footer />

        <MyToast />
        <MenuBar v-if="globalSettings?.mainUiInterface?.mobileBarUiType !== 'mobileBar_hide'" />
        <MobileMenu />
        <EcomMyModal />
        <template v-if="noScriptCode">
            <noscript v-html="noScriptCode"></noscript>
        </template>
    </div>
</template>

<script>
import themeStylesVars from '~/themes/novaporta/assets/styles/vars';
import { convertJSONStylesToGlobalVarsContent } from '~/utils/convertors';
import { mapGetters } from 'vuex';
import dynamicFont from '~/mixins/dynamicFont';

export default {
    components: {
        Header: () => import('~/themes/novaporta/components/widgets/Header'),
        Footer: () => import('~/themes/novaporta/components/widgets/Footer'),
        Navigation: () => import('~/themes/novaporta/components/widgets/Navigation'),
        MobileMenu: () => import('~/themes/novaporta/components/widgets/MobileMenu'),
        MenuBar: () => import('~/themes/novaporta/components/widgets/MenuBar'),
        MyToast: () => import('~/themes/novaporta/components/ui/MyToast'),
        CallUs: () => import('~/themes/novaporta/components/reusable/CallUs'),
        Scroller: () => import('~/themes/novaporta/components/widgets/Scroller'),
        EcomMyModal: () => import('@/components/modals/EcomMyModal.vue')
    },
    mixins: [dynamicFont],
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getIcons: 'global/getIcons',
            noScriptCode: 'global/getNoScriptCode'
        }),
        projectName() {
            return this.globalSettings.project;
        },
        colors() {
            return this.globalSettings.colors.dark_theme || null;
        },
        logo() {
            return this.globalSettings?.logo?.logoDark || null;
        },
        getFavicon() {
            return this.getIcons?.favicon || this.logo;
        }
    },
    watch: {
        '$i18n.locale': async function (newVal, oldVal) {
            // Not reliable solution
            this.$fetch();
            await this.$store.dispatch('footer/fetchFooterSettings');
            await this.$store.dispatch('global/fetchGlobalSettings');

            // const modals = await this.$axios.$get('/base/pop-up-configuration');
            //
            // await this.$store.dispatch('modals/setModals', modals);
            if (process.client) {
                const cart = JSON.parse(localStorage.getItem('cart_products_novaporta'));

                if (cart) {
                    const urlProducts = [];
                    const newUrlProducts = [];
                    const newProducts = [];

                    cart.forEach(item => {
                        urlProducts.push(item.slug);
                    });

                    const promises = urlProducts.map(async item => {
                        const request = await this.$axios.$post('general/slug_check', {
                            new_lang: this.$i18n.locale,
                            current_slug: item,
                            object_type: 'product'
                        });
                        return request.slug;
                    });

                    const results = await Promise.all(promises);

                    newUrlProducts.push(...results);

                    const promisesProducts = newUrlProducts.map(async item => {
                        const { data } = await this.$api.product.getProduct(item);

                        return {
                            id: data.product.productId,
                            slug: data.product?.url
                        };
                    });

                    const resultsProducts = await Promise.all(promisesProducts);

                    newProducts.push(...resultsProducts);

                    const updatedCart = cart.map(item => {
                        return {
                            ...item,
                            ...newProducts.find(prod => prod.id === item.id)
                        };
                    });

                    localStorage.setItem('cart_products_novaporta', JSON.stringify(updatedCart));
                }
            }
        }
    },
    async mounted() {
        await this.$store.dispatch('utms/setTheUtms', {
            utm_source: this.$route.query.utm_source || '',
            utm_medium: this.$route.query.utm_medium || '',
            utm_campaign: this.$route.query.utm_campaign || '',
            utm_term: this.$route.query.utm_term || '',
            utm_content: this.$route.query.utm_content || ''
        });
    },
    async fetch() {
        await this.$store.dispatch('categories/fetchCategories');
        // const modals = await this.$axios.$get('/base/pop-up-configuration');
        //
        // this.$store.dispatch('modals/setModals', modals);
    },
    mounted() {
        const ga4Id = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_analytics_4;

        if (ga4Id) {
            // Первый скрипт для загрузки gtag.js
            const scriptEl1 = document.createElement('script');
            scriptEl1.async = true;
            scriptEl1.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
            document.head.insertAdjacentElement('afterbegin', scriptEl1);

            // Второй скрипт для конфигурации
            const scriptEl2 = document.createElement('script');
            scriptEl2.innerHTML = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${ga4Id}');
`;
            document.head.insertAdjacentElement('afterbegin', scriptEl2);
        }
        const gtmId = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_tag_manager;
        const metaPixelCodeId = this.$store.state.global.globalSettings?.sitesettingsstatistic?.facebook_meta_pixel_code;
        if (gtmId) {
            const scriptEl = document.createElement('script');
            scriptEl.innerHTML = `
                    (function(w,d,s,l,i){
                        w[l] = w[l] || [];
                        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
                        var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s),
                            dl = l !== 'dataLayer' ? '&l='+l : '';
                        j.async = true;
                        j.src = 'https://www.googletagmanager.com/gtm.js?id='+i+dl;
                        f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${gtmId}');
                    `;

            document.head.insertAdjacentElement('afterbegin', scriptEl);
        }

        if (gtmId) {
            const gtmNoScript = `
                <!-- Google Tag Manager (noscript) -->
                <noscript>
                <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
                        height="0" width="0" style="display:none;visibility:hidden"></iframe>
                </noscript>
                <!-- End Google Tag Manager (noscript) -->
            `;
            document.body.insertAdjacentHTML('afterbegin', gtmNoScript);
        }

        if (metaPixelCodeId) {
            const metaPixelScript = document.createElement('script');
            metaPixelScript.async = true;
            metaPixelScript.text = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${metaPixelCodeId}');
    fbq('track', 'PageView');
  `;
            // Вставляем созданный <script> в конец тега <head>
            document.head.insertAdjacentElement('beforeend', metaPixelScript);

            // Создаем noscript-блок для Meta Pixel Code
            const metaPixelNoScript = `
    <!-- Meta Pixel Code -->
    <noscript>
      <img height="1" width="1" style="display:none"
           src="https://www.facebook.com/tr?id=${metaPixelCodeId}&ev=PageView&noscript=1"/>
    </noscript>
    <!-- End Meta Pixel Code -->
  `;
            // Вставляем noscript-блок в конец тега <head>
            document.head.insertAdjacentHTML('beforeend', metaPixelNoScript);
        }
    },
    head() {
        const scripts = [];
        const styles = [
            {
                hid: 'theme-css-variables',
                innerHTML: convertJSONStylesToGlobalVarsContent(themeStylesVars, this.colors),
                type: 'text/css'
            }
        ];
        const metas = [];

        const css = this.$store.state.global.globalSettings?.styles?.css;
        const js = this.$store.state.global.globalSettings?.styles?.script;

        const facebookVerification = this.$store.state.global.globalSettings?.sitesettingsstatistic?.facebook_verification;
        const googleAnalytics4 = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_analytics_4;
        const googleSearchConsole = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_search_console;
        const googleTagManager = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_tag_manager;
        const yandexMetrika = this.$store.state.global.globalSettings?.sitesettingsstatistic?.yandex_metrika;

        if (facebookVerification) {
            metas.push({
                hid: 'facebook-domain-verification',
                name: 'facebook-domain-verification',
                content: facebookVerification
            });
        }

        if (googleSearchConsole) {
            metas.push({
                hid: 'google-site-verification',
                name: 'google-site-verification',
                content: googleSearchConsole
            });
        }

        // if (process.client) {
        if (googleAnalytics4) {
            // scripts.push({
            //     hid: 'google-analytics-gtag',
            //     src: `https://www.googletagmanager.com/gtag/js?id=${googleAnalytics4}`,
            //     async: true
            // });
            // scripts.push({
            //     hid: 'google-analytics-config',
            //     innerHTML: `
            //             window.dataLayer = window.dataLayer || [];
            //             function gtag(){dataLayer.push(arguments);}
            //             gtag('js', new Date());
            //             gtag('config', '${googleAnalytics4}');
            //         `
            // });
        }

        if (googleTagManager) {
            // scripts.push({
            //     hid: 'google-tag-manager',
            //     innerHTML: `
            //             (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            //             var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            //             j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            //             })(window,document,'script','dataLayer','${googleTagManager}');
            //         `
            // });
        }

        if (yandexMetrika) {
            scripts.push({
                hid: 'yandex-metrika',
                innerHTML: `
                        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0];k.async=1;k.src=r;a.parentNode.insertBefore(k,a)})
                        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                        ym(${yandexMetrika}, "init", {
                            clickmap:true,
                            trackLinks:true,
                            accurateTrackBounce:true
                        });
                    `
            });
        }
        // }

        if (js) {
            scripts.push({
                hid: 'custom-js',
                innerHTML: js,
                type: 'text/javascript'
            });
        }

        if (css) {
            styles.push({
                hid: 'custom-css',
                innerHTML: css,
                type: 'text/css'
            });
        }

        return {
            __dangerouslyDisableSanitizersByTagID: {
                'custom-js': ['innerHTML'],
                'google-analytics-config': ['innerHTML'],
                'google-tag-manager': ['innerHTML'],
                'yandex-metrika': ['innerHTML']
            },
            title: this.projectName,
            bodyAttrs: {
                style: `font-family: ${this.foundFontFile || 'Onest'}, sans-serif;`
            },
            link: [
                {
                    rel: 'shortcut icon',
                    href: this.getFavicon
                },
                {
                    rel: 'stylesheet',
                    href: 'https://fonts.googleapis.com/css2?family=Onest:wght@100..900&display=swap'
                },
                {
                    rel: 'preconnect',
                    href: 'https://fonts.googleapis.com'
                },
                {
                    rel: 'preconnect',
                    href: 'https://fonts.gstatic.com',
                    crossorigin: true
                }
            ],
            meta: metas,
            style: styles,
            script: scripts,
            htmlAttrs: {
                lang: this.$i18n.locale || 'en'
            }
        };
    }
};
</script>
<style lang="scss">
html {
    zoom: 0.9;
}
</style>
